import React from "react";
import { Workflow, BCMSDate, useBCMSContext, useParams, useModel } from "@bcm-dev/bcms-vite";
import BalanceTransfersPage from "components/pages/BalanceTransfersPage";
import TransferAmountView from "components/pages/BalanceTransfersPage/components/TransferAmountView";
import TransferRecipientInfoView from "components/pages/BalanceTransfersPage/components/TransferRecipientInfoView";
import TransferReviewDetailsView from "components/pages/BalanceTransfersPage/components/TransferReviewDetailsView";
import TransferConfirmationView from "components/pages/BalanceTransfersPage/components/TransferConfirmationView";

const steps = [<BalanceTransfersPage view={ <TransferAmountView /> }/>,
<BalanceTransfersPage view={ <TransferRecipientInfoView /> }/>,
<BalanceTransfersPage view={ <TransferReviewDetailsView /> }/>,
<BalanceTransfersPage view={ <TransferConfirmationView /> }/>];

/**
 * @function BalanceTransferWorkflow
 * @returns {React.Component}
 * @description The main component for the balance transfers workflow.
 * @exported true
 * @example <BalanceTransferWorkflow />
 */
export default function BalanceTransferWorkflow(props) {
    const controller = useBCMSContext();
    const cardID = useParams().cardID ?? "0";
    const model = useModel();
    const value = getDefault(model.user.email);
    return <Workflow value={ value } steps={ steps } />;
}

/**
 * @function getWorkflowSteps
 * @returns {ARRAY}
 * @description Hook to return the steps of the workflow
 * @exported true
 */
export const getWorkflowSteps = () => steps;

/**
 * @function getDefault
 * @returns {OBJECT}
 * @exported true
 * @description Returns the default values for the travel plan
 */
export const getDefault = (email) => {

    return {
        transferAmount: "",
        creditCardNum: "",
        fi: "",
        fiAddress: "",
        city: "",
        state: "",
        zip: "",
        email: email,
        requestDate: BCMSDate.init()
    }
};